var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('intranet-dashboard',[_c('template',{slot:"routes"},[_c('sidebar-item-exact',{attrs:{"link":{ name: 'Dashboard', icon: 'ni ni-tv-2 text-blue', path: { name: 'notActiveRoles-dashboard' } }}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }